import angular from 'angular';
import { horizontalRowModule } from '../HorizontalRow/HorizontalRow.module';
import { noShowsModule } from '../NoShows/NoShows.module';
import { HorizontalTableController } from './HorizontalTable.controller';
import template from './HorizontalTable.template.html';

export const horizontalTableModule = angular
  .module('bit.components.HorizontalTable', [
    horizontalRowModule.name,
    noShowsModule.name,
  ])
  .directive('bitHt', () => ({
    scope: {
      divider: '=',
      mobile: '=',
    },
    template,
    restrict: 'E',
    controller: HorizontalTableController,
    controllerAs: 'htc',
  }));
